export enum ExecuteOrderStatus {
  NotStarted = 1,
  InProgress = 2,
  Completed = 3,
  All = 0,
  Assigned = 6,
  INACTIVE = 4,
  COMPLETED_INACTIVE = 5,
  Planned = 8
}